export default {
  "lang.label": "語言",
  "lang.zh-TW": "繁中",
  "lang.zh-CN": "簡中",
  "lang.en": "英文",
  "lang.ja": "日文",
  "nav.home": "首頁",
  "nav.about": "品牌介紹",
  "nav.books": "書籍資料庫",
  "nav.stores": "合作通路",
  "nav.faq": "常見問題",
  "nav.blog": "編輯選書",
  "nav.contact": "聯絡我們",
  "nav.partners": "合作夥伴",
  "nav.services": "服務內容",
  "nav.app": "爽讀 App",
  "nav.more": "更多",
};
